export const mimeTypeForHeader = (headerString: string) => {
    switch (headerString) {
        case '89504e47':
            return 'image/png';
        case '47494638':
            return 'image/gif';
        case 'ffd8ffee':
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
            return 'image/jpeg';
        case '424d':
            return 'image/bmp';
        case '00000100':
            return 'image/vnd.microsoft.icon';
        case '492049':
        case '49492a00':
        case '4d4d002a':
        case '4d4d002b':
            return 'image/tiff';
        case '52494646':
            return 'video/x-msvideo';
        case '66747970':
        case '00020':
        case '00014':
            return 'video/mp4';
        case '000001ba':
        case '000001b3':
            return 'video/mpeg';
        case '4F676753':
            return 'video/ogg';
        case '1a45dfa3':
            return 'video/webm';
        case '25504446':
        case '58354f21':
            return 'application/pdf';
        default:
            return 'unknown';
    }
};
